// Module
var code = `<canvas></canvas>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-scoring/credit-scoring-modal-score-chart.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;